// src/services/api.js

import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "https://quivix-backend.onrender.com";

const apiClient = axios.create({
  baseURL: `${API_URL}/api`,
});

/**
 * Cloudinary always provides a full absolute URL, so we just return the path directly.
 */
export const getMediaUrl = (path) => {
  return path || "";
};

// --- API functions to fetch data from the backend. ---

export const getApps = () => apiClient.get("/apps");
export const getJobs = () => apiClient.get("/jobs");
export const getAppDetails = (appId) => apiClient.get(`/apps/${appId}`);
export const getTeamMembers = () => apiClient.get("/team");
